mutation RemoveUserFromWorkspace($workspaceId: ID!) {
    removeCurrentUserFromWorkspace(workspaceId: $workspaceId) {
        id
        name
    }
}
